import { AbstractControl, FormGroup, UntypedFormGroup } from '@angular/forms';

export class FormControlUtils {
    public static updateStyleClassValidity(form: UntypedFormGroup, formControlName: string): string {
        if (!form.controls[formControlName]?.valid && form.controls[formControlName]?.dirty) {
            return 'invalid';
        }
        return 'valid';
    }

    public static markAllControlsAsDirty(form: UntypedFormGroup) {
        Object.keys(form.controls).forEach(controlName => {
            form.controls[controlName].markAsDirty();
        });
    }

    public static markFormsAsDirty(forms: UntypedFormGroup[]): void {
        forms.forEach(form => this.markAllControlsAsDirty(form));
    }

    public static markControlAsDirtyAndValidate(control: AbstractControl | null | undefined): void {
        control?.markAsDirty();
        control?.updateValueAndValidity();
    }

    public static updateFormValueAndValidity(form: UntypedFormGroup): void {
        Object.keys(form.controls).forEach(control => form.controls[control].updateValueAndValidity());
    }

    public static validateForm(formGroup: FormGroup): boolean {
        FormControlUtils.updateFormValueAndValidity(formGroup);
        FormControlUtils.markAllControlsAsDirty(formGroup);
        return formGroup.valid;
    }
}
